module.exports = "<slot _v-15ba69ca=\"\"></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/template-rewriter.js?id=_v-15ba69ca&file=TabGroup.vue!./~/.npminstall/vue-loader/7.1.7/vue-loader/lib/selector.js?type=template&index=0!./src/TabGroup.vue
// module id = 330
// module chunks = 0